export const newsRedirections = [
	// {
	// 	fromID: '151',
	// 	toRoute: '/aktualnosc/192/najwieksze-lotniska-w-polsce-w-2019',
	// },
	{
		fromID: '231',
		toRoute: '/',
	},
	{
		fromID: '150',
		toRoute: '/samochody',
	},
	{
		fromID: '164',
		toRoute: '/faq',
	},
	{
		fromID: '178',
		toRoute: '/',
	},
	{
		fromID: '189',
		toRoute: '/wynajem-dlugoterminowy',
	},
	{
		fromID: '193',
		toRoute: '/aktualnosc/182/wynajem-samochodu-bez-karty-kredytowej-i-depozytu-czy-to-mozliwe',
	},
	{
		fromID: '136',
		toRoute: '/aktualnosc/338/co-warto-zobaczyc-w-krakowie-atrakcje-krakow',
	},
	{
		fromID: '137',
		toRoute: '/aktualnosc/340/co-warto-zobaczyc-we-wroclawiu-atrakcje-wroclaw',
	},
	{
		fromID: '138',
		toRoute: '/aktualnosc/341/atrakcje-poznan-co-warto-zobaczyc-w-poznaniu',
	},
	{
		fromID: '151',
		toRoute: '/aktualnosc/195/wynajem-samochodu-w-podroz-sluzbowa-za-granice-informacje-praktyczne',
	},
	{
		fromID: '156',
		toRoute: '/aktualnosc/183/wynajem-samochodu-a-dodatkowe-ubezpieczenie-co-obejmuje-podstawowe-ubezpieczenie-samochodu-z-wypozyczalni',
	},
	{
		fromID: '187',
		toRoute: '/aktualnosc/369/co-warto-zobaczyc-w-bydgoszczy-atrakcje-bydgoszcz-i-okolice',
	},
	{
		fromID: '199',
		toRoute: '/wynajem-busow-osobowych',
	},
	{
		fromID: '201',
		toRoute: '/aktualnosc/373/co-warto-zobaczyc-w-szczecinie-atrakcje-szczecin',
	},
	{
		fromID: '202',
		toRoute: '/aktualnosc/392/lublin-co-warto-zobaczyc-glowne-atrakcje-lublina-i-okolic',
	},
	{
		fromID: '203',
		toRoute: '/aktualnosc/368/co-warto-zobaczyc-w-olsztynie-atrakcje-olsztyn-i-okolice',
	},
	{
		fromID: '204',
		toRoute: '/aktualnosc/346/co-warto-zobaczyc-w-katowicach-atrakcje-katowice',
	},
	{
		fromID: '206',
		toRoute: '/aktualnosc/391/warszawa-i-glowne-atrakcje-turystyczne-co-warto-zobaczyc-bedac-w-stolicy',
	},
	{
		fromID: '214',
		toRoute: '/aktualnosc/374/co-warto-zobaczyc-w-kielcach-atrakcje-kielce-i-okolice',
	},
	{
		fromID: '215',
		toRoute: '/aktualnosc/369/co-warto-zobaczyc-w-bydgoszczy-atrakcje-bydgoszcz-i-okolice',
	},
	{
		fromID: '220',
		toRoute: '/aktualnosc/339/atrakcje-gdansk-co-warto-zobaczyc-w-gdansku',
	},
	{
		fromID: '226',
		toRoute: '/aktualnosc/235/jak-przygotowac-samochod-z-wypozyczalni-do-jazdy-zima-o-czym-pamietac-zanim-ruszymy-w-podroz',
	},
	{
		fromID: '229',
		toRoute: '/wynajem-srednioterminowy',
	},
]
